module.exports = __webpack_public_path__ + "e0efda29dc1012add58d03eb449ccd5c.svg";